import React from 'react';

export default function RichTextEmbeddedAsset(props) {
    // If we have no marks, render the value itself
    switch (props.asset.file.contentType) {
        case 'image/png':
        case 'image/jpeg':
        case 'image/jpg':
            return (
                <a href={props.asset.file.url} target={'_blank'}>
                    <img
                        style={{height: 'auto', maxWidth: '100%', display: 'block', margin: '20px auto', width: '50%'}}
                        src={props.asset.file.url}
                        alt={props.asset.title}
                    />
                </a>
            )
        default:
            // TODO - Add error handling / logging when attempting to render an embedded asset of unknown content type (image/svg, video, etc.)
            return null;
    }
}
